import { FaultReason } from '../../../api/api-site-alerts';

export type SiteAlertsQueryParams = { limit: number; offset: number };

export const FAULT_REASON_TO_TITLE_MAP: Record<FaultReason, string> = {
  ZERO_PRODUCTION: 'Zero Production',
  METER_OFFLINE: 'Meter Offline',
  SUBSCRIPTION_EXPIRED: 'Subscription Expired',
};
